/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Rights_ReservedInputs */

const tr_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Hakları Saklıdır`)
};

const en_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Rights Reserved`)
};

const de_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Rechte vorbehalten`)
};

const ru_footer_rights_reserved = /** @type {(inputs: Footer_Rights_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все права защищены`)
};

/**
* | output |
* | --- |
* | "All Rights Reserved" |
*
* @param {Footer_Rights_ReservedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const footer_rights_reserved = /** @type {((inputs?: Footer_Rights_ReservedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Rights_ReservedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_rights_reserved(inputs)
	if (locale === "de") return de_footer_rights_reserved(inputs)
	if (locale === "ru") return ru_footer_rights_reserved(inputs)
	return tr_footer_rights_reserved(inputs)
});